import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './pricing.css'

const Pricing = (props) => {
  return (
    <div className="pricing-container1">
      <Helmet>
        <title>Pricing - ClearPath Digital</title>
        <meta property="og:title" content="Pricing - ClearPath Digital" />
        <link
          rel="canonical"
          href="https://clearpathdigital.teleporthq.app/pricing"
        />
      </Helmet>
      <Navigation></Navigation>
      <main className="pricing-page">
        <section className="pricing-thq-pricing-hero-elm pricing-hero">
          <div className="pricing-hero-container">
            <div className="pricing-hero-card">
              <h1 className="hero-title">
                Transparent Pricing for High-Converting Websites
              </h1>
              <p className="hero-subtitle">
                Outcome-focused packages designed for businesses, startups, and
                service companies looking for a sales asset, not just a
                &quot;pretty site&quot;.
              </p>
              <div className="pricing-hero-actions">
                <Link to="/contact-book-a-call">
                  <div className="pricing-thq-btn-elm1 btn btn-primary btn-lg">
                    <span>Book a free website strategy call</span>
                  </div>
                </Link>
              </div>
              <p className="pricing-hero-reassurance">
                Premium performance starting from €2,500. No hidden fees.
              </p>
            </div>
          </div>
        </section>
      </main>
      <div className="pricing-container2">
        <div className="pricing-container3">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;
transform: translateY(20px);}
to {opacity: 1;
transform: translateY(0);}}@keyframes slideInLeft {from {opacity: 0;
transform: translateX(-30px);}
to {opacity: 1;
transform: translateX(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="pricing-container4">
        <div className="pricing-container5">
          <Script
            html={`<script defer data-name="pricing-logic">
(function(){
  // Handle smooth reveals for timeline items
  const timelineItems = document.querySelectorAll('.timeline-item');
  
  const revealOnScroll = () => {
    const triggerBottom = window.innerHeight * 0.85;
    
    timelineItems.forEach(item => {
      const itemTop = item.getBoundingClientRect().top;
      
      if(itemTop < triggerBottom) {
        item.style.opacity = '1';
        item.style.transform = 'translateX(0)';
      }
    });
  };

  // Set initial state for JS-driven reveal
  timelineItems.forEach(item => {
    item.style.opacity = '0';
    item.style.transform = 'translateX(-30px)';
    item.style.transition = 'all 0.6s ease-out';
  });

  window.addEventListener('scroll', revealOnScroll);
  revealOnScroll(); // Initial check

  // Form interactivity enhancement
  const quoteForm = document.querySelector('.quote-form');
  if (quoteForm) {
    quoteForm.addEventListener('submit', (e) => {
      // Native validation will run first.
      // This is just to provide visual feedback if needed post-validation.
      const btn = quoteForm.querySelector('button[type="submit"]');
      btn.textContent = 'Sending...';
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
    });
  }

  // Horizontal scroll behavior for testimonials
  const rail = document.querySelector('.testimonials-rail');
  let isDown = false;
  let startX;
  let scrollLeft;

  if (rail) {
    rail.addEventListener('mousedown', (e) => {
      isDown = true;
      rail.classList.add('active');
      startX = e.pageX - rail.offsetLeft;
      scrollLeft = rail.scrollLeft;
    });
    rail.addEventListener('mouseleave', () => {
      isDown = false;
      rail.classList.remove('active');
    });
    rail.addEventListener('mouseup', () => {
      isDown = false;
      rail.classList.remove('active');
    });
    rail.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - rail.offsetLeft;
      const walk = (x - startX) * 2;
      rail.scrollLeft = scrollLeft - walk;
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <section className="pricing-section">
        <div className="container">
          <div className="pricing-header">
            <h2 className="section-title">Clear, Simple Pricing</h2>
            <p className="section-subtitle">
              Choose the package that fits your business needs. All websites are
              built to convert, load fast, and look professional.
            </p>
          </div>
          <div className="pricing-cards-wrapper">
            <div className="pricing-pricing-card starter-card">
              <div className="starter-indicator pricing-card-indicator"></div>
              <div className="pricing-pricing-card-header">
                <h3 className="pricing-card-title">Starter Website</h3>
                <p className="pricing-card-audience">
                  Best for: associations, small local businesses, first
                  professional website
                </p>
                <div className="pricing-pricing-card-price">
                  <span className="pricing-price-label">Starting at</span>
                  <span className="pricing-price-value">€400</span>
                </div>
              </div>
              <div className="pricing-card-body">
                <ul className="pricing-features-list">
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>1-page website (scrolling page)</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Clear structure (who / what / why / contact)</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Mobile-first design</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Fast loading</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Contact form or email CTA</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Basic SEO setup (titles, descriptions)</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Deployment + SSL (Cloudflare)</span>
                  </li>
                </ul>
                <div className="pricing-pricing-timeline">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6v6l4 2"></path>
                      <circle r="10" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                  <span>Timeline: 5–7 days</span>
                </div>
              </div>
              <div className="pricing-card-footer">
                <Link
                  to="/contact-book-a-call"
                  className="pricing-thq-btn-elm2 btn-outline btn pricing-cta"
                >
                  Get Started
                </Link>
              </div>
            </div>
            <div className="pricing-pricing-card featured-card business-card">
              <div className="pricing-badge">
                <span>Most Popular</span>
              </div>
              <div className="business-indicator pricing-card-indicator"></div>
              <div className="pricing-pricing-card-header">
                <h3 className="pricing-card-title">Business Website</h3>
                <p className="pricing-card-audience">
                  Best for: organizations that need clarity, credibility, and
                  conversions
                </p>
                <div className="pricing-pricing-card-price">
                  <span className="pricing-price-label">Starting at</span>
                  <span className="pricing-price-value">€800</span>
                </div>
              </div>
              <div className="pricing-card-body">
                <ul className="pricing-features-list">
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      4–6 pages (Home, About, Services, Contact, etc.)
                    </span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Conversion-focused structure</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Clear CTAs on every page</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Mobile + desktop optimization</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Speed optimization</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Contact form(s) + basic tracking</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Basic on-page SEO</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Deployment + SSL</span>
                  </li>
                </ul>
                <div className="pricing-pricing-timeline">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6v6l4 2"></path>
                      <circle r="10" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                  <span>Timeline: 7–14 days</span>
                </div>
              </div>
              <div className="pricing-card-footer">
                <Link
                  to="/contact-book-a-call"
                  className="pricing-thq-btn-elm3 btn btn-primary pricing-cta"
                >
                  Get Started
                </Link>
              </div>
            </div>
            <div className="pricing-pricing-card advanced-card">
              <div className="advanced-indicator pricing-card-indicator"></div>
              <div className="pricing-pricing-card-header">
                <h3 className="pricing-card-title">
                  Advanced / Custom Website
                </h3>
                <p className="pricing-card-audience">
                  Best for: hubs, institutions, businesses with multiple
                  audiences or goals
                </p>
                <div className="pricing-pricing-card-price">
                  <span className="pricing-price-label">Starting at</span>
                  <span className="pricing-price-value">€1,200</span>
                </div>
              </div>
              <div className="pricing-card-body">
                <ul className="pricing-features-list">
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Custom structure (6–10+ pages)</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Strategy call + content guidance</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Advanced layout &amp; UX</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Multiple CTAs (contact, signup, visit, etc.)</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Performance &amp; mobile optimization</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>SEO-ready structure</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Analytics setup</span>
                  </li>
                  <li className="pricing-feature-item">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Deployment + SSL</span>
                  </li>
                </ul>
                <div className="pricing-pricing-timeline">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6v6l4 2"></path>
                      <circle r="10" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                  <span>Timeline: 2–3 weeks</span>
                </div>
              </div>
              <div className="pricing-card-footer">
                <Link
                  to="/contact-book-a-call"
                  className="pricing-thq-btn-elm4 btn-outline btn pricing-cta"
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
          <div className="add-ons-section">
            <h3 className="add-ons-title">Optional Add-Ons</h3>
            <p className="add-ons-subtitle">
              Enhance your website with additional services tailored to your
              specific needs
            </p>
            <div className="add-ons-grid">
              <div className="add-on-card">
                <div className="add-on-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                    </g>
                  </svg>
                </div>
                <h4 className="add-on-name">Extra Page</h4>
                <p className="add-on-description">
                  Add additional pages to your website as your business grows
                </p>
                <p className="add-on-price">€80–120 / page</p>
              </div>
              <div className="add-on-card">
                <div className="add-on-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h4 className="add-on-name">Website Copywriting Help</h4>
                <p className="add-on-description">
                  Professional copy that converts visitors into customers
                </p>
                <p className="add-on-price">€150–300</p>
              </div>
              <div className="add-on-card">
                <div className="add-on-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                    </g>
                  </svg>
                </div>
                <h4 className="add-on-name">Multilingual Setup</h4>
                <p className="add-on-description">
                  EN / FR / other languages (content provided by you)
                </p>
                <p className="add-on-price">€100–250</p>
              </div>
              <div className="add-on-card">
                <div className="add-on-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <circle r="6" cx="12" cy="12"></circle>
                      <circle r="2" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <h4 className="add-on-name">
                  Contact &amp; Conversion Optimization
                </h4>
                <p className="add-on-description">
                  Fine-tune your forms and CTAs for maximum conversions
                </p>
                <p className="add-on-price">€100–200</p>
              </div>
              <div className="highlight-card add-on-card">
                <div className="add-on-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 12h14m-7-7l7 7l-7 7"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h4 className="add-on-name">Website Audit</h4>
                <p className="add-on-description">
                  Comprehensive analysis of your existing website
                </p>
                <p className="add-on-price">€50–100</p>
                <span className="add-on-note">Free if you become a client</span>
              </div>
            </div>
          </div>
          <div className="pricing-footer-cta">
            <h3 className="pricing-footer-title">
              Not sure which package is right for you?
            </h3>
            <p className="pricing-footer-text">
              Book a free 15-minute strategy call and we&apos;ll help you choose
              the best solution for your business goals.
            </p>
            <Link
              to="/contact-book-a-call"
              className="pricing-thq-btn-elm5 btn btn-primary btn-lg"
            >
              Book Free Strategy Call
            </Link>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </div>
  )
}

export default Pricing
